import { styled } from "@mui/system";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";

type PatientColorMap = string;
//region [[ Styles ]]

export const scrollableStyleByColor = (
  color: KahunColorMap | PatientColorMap,
): React.CSSProperties & {"&::-webkit-scrollbar": any, "&::-webkit-scrollbar-thumb": any} =>
  ({
    overflowY: "auto",
    overflowX: "auto",
    height: "100%",
    // Firefox support
    scrollbarColor: color,
    scrollbarWidth: "thin",
    "&::-webkit-scrollbar": {
      background: "transparent",
      width: "5px",
      height: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: color,
      borderRadius: "6px",
      border: "none",
    },
  });

export const scrollableStyle = scrollableStyleByColor(
  KahunColorMap.DisabledBackground,
);

export const ScrollableContainer = styled("div")({
  ...scrollableStyle,
});

//endregion [[ Styles ]]
